import { Button, Grid, Switch, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';

// Components
import Modal from '../../../../components/modal/index';
import ProductInput from '../../../../components/inputs/input';
import Dropdown from '../../../../components/inputs/dropdown';
import Autocomplete from '../../../../components/inputs/Autocomplete';

//models
import { FloorDepartment, AddressDepartment } from '../../../../models/EnumEntity';

// Hooks 
import useGeo from '../../../../hooks/countries/useGeo';

const CreateAddress = ({ onSave, address, modalProps }) => {
  const { countries, states, cities, selectCountry, selectState } = useGeo();
  const [newItem, setNewItem] = useState(address || null);

  const handleInputChange = (event) =>
    setNewItem({
      ...newItem,
      [event.target.name]: event.target.value
    });

  useEffect(() => {
    const setCountry = async () => {
      if (!newItem?.country) return;
      await selectCountry(newItem.country)
    }
    setCountry()
  }, [selectCountry, newItem?.country])

  useEffect(() => {
    const setState = async () => {
      if (!newItem?.province || states.length <= 0) return;
      const stateSelected = states.find(s => s.name === newItem.province) || states[0];
      await selectState(stateSelected.id)
    }
    setState()
  }, [newItem?.province, states])



  const isFromValid = () => {
    if (!newItem?.street)
      return false;

    if (!newItem?.number)
      return false;

    if (!newItem?.province)
      return false;

    if (!newItem?.city)
      return false;

    if (!newItem?.postalCode)
      return false;

    if (!newItem?.country)
      return false;

    return true;
  }

  const handleSwitchChange = async (event) => {
    setNewItem({
      ...newItem,
      [event.target.name]: event.target.checked
    });
  }

  const handleAutocompleteChange = (_, option) => {
    setNewItem({
      ...newItem,
      city: option?.name
    });
  }

  return (
    <Modal
      disableEscapeKeyDown
      fullWidth
      title={!address ? "Crear dirección" : "Editar dirección"}
      dividers
      {...modalProps}
    >
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}
        >
          <Dropdown
            data-cy="addressCountry"
            fullWidth
            required
            name="country"
            label="País"
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.code}
            value={newItem?.country}
            values={countries}
            onChange={handleInputChange}
            error={!newItem?.country}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}
        >
          <Dropdown
            fullWidth
            required
            label="Provincia"
            name="province"
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.name}
            value={newItem?.province}
            values={states || []}
            onChange={handleInputChange}
            error={!newItem?.province}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}
        >
          <Autocomplete
            required
            fullWidth
            options={cities || []}
            getOptionLabel={option => option?.name || ''}
            renderOption={(props, option) => (<li {...props}><span>{option?.name || ''}</span></li>)}
            onChange={handleAutocompleteChange}
            value={cities?.find(c => c.name === newItem?.city) || null}
            TextProps={{
              label: 'Ciudad',
              name: 'city',
              required: true,
              error: !newItem?.city
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}
        >
          <ProductInput
            fullWidth
            required
            label="Codigo postal"
            name="postalCode"
            onChange={handleInputChange}
            value={newItem?.postalCode}
            error={!newItem?.postalCode}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}
        >
          <ProductInput
            fullWidth
            required
            label="Calle"
            name="street"
            onChange={handleInputChange}
            value={newItem?.street}
            error={!newItem?.street}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}
        >
          <ProductInput
            fullWidth
            required
            label="Número"
            name="number"
            onChange={handleInputChange}
            value={newItem?.number}
            error={!newItem?.number}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}
        >
          <Dropdown
            fullWidth
            label="Piso"
            name="floor"
            placeholder="Ninguno"
            onChange={handleInputChange}
            getOptionLabel={(option) => option?.label}
            getOptionValue={(option) => option?.label}
            values={FloorDepartment || []}
            value={newItem?.floor}
            placeholderDisabled={false}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}
        >
          <Dropdown
            fullWidth
            label="Departamentos"
            name="apartment"
            placeholder="Ninguno"
            onChange={handleInputChange}
            getOptionLabel={(option) => option?.label}
            getOptionValue={(option) => option?.label}
            values={AddressDepartment || []}
            value={newItem?.apartment}
            placeholderDisabled={false}
          />
        </Grid>
        <Grid size={12}>
          <ProductInput
            fullWidth
            multiline
            rows={4}
            name="observation"
            label="Información complementaria"
            onChange={handleInputChange}
            value={newItem?.observation || ""}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}
        >
          <Switch
            color="primary"
            name="isInvoice"
            onChange={handleSwitchChange}
            checked={newItem?.isInvoice}
            disabled={address && address.isInvoice}
          />
          <Typography>
            {newItem?.isInvoice ? "SI de Facturación" : "NO de Facturación"}
          </Typography>
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}
        >
          <Switch
            color="primary"
            name="isShipping"
            onChange={handleSwitchChange}
            checked={newItem?.isShipping}
            disabled={address && address.isShipping}
          />
          <Typography>
            {newItem?.isShipping ? "SI de Entrega" : "NO de entrega"}
          </Typography>
        </Grid>
        <Grid container justifyContent="space-between" size={12}>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => modalProps.onClose()}
          >
            Cancelar
          </Button>
          <Button
            name="createAddressSave"
            disabled={!isFromValid()}
            onClick={() => {
              onSave(newItem);
            }}
            color="primary"
            variant="contained"
          >
            Guardar
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
}

export default CreateAddress;
